import React from "react";
import "./Qucik_Rides.css";
import { Container, Row, Col } from "react-bootstrap";
import Common_Service_Card from "../../common_component/common-service-card/Common_Service_Card";

const Qucik_Rides = () => {
  const servicesData = [
    {
      title: "Book a Ride",
      image: "/assets/images/common-service-card/taxi.png",
    },
    {
      title: "Easy Transport",
      image: "/assets/images/common-service-card/truck.png",
    },
    {
      title: "Share Taxi & Bus",
      image: "/assets/images/common-service-card/bus.png",
    },
  ];

  return (
    <section className="quick-rides-section">
      <Container>
        <Row>
          <Col>
            <h2 className="quick-rides-title">Qucik Rides</h2>
            <Row className="g-4">
              {servicesData.map((service, index) => (
                <Col lg={4} md={4} sm={6} xs={6} key={index}>
                  <Common_Service_Card
                    title={service.title}
                    image={service.image}
                  />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default Qucik_Rides;
